import React from 'react'
import './create_button.css'
import AddIcon from '@mui/icons-material/Add';
export default function CreateButtonForAllScreen({ haveDomain, redMessage, buttonMessage, domain, onClick }) {
    return (
        <div id='create-button-all'>
            {haveDomain ?
                <div className="domain-name">
                    {domain}
                </div> : <></>
            }
            <div onClick={() => onClick(false)} className="create-event-button">
                <div className="message-text">{redMessage}</div>
                <div className="create-event-icon-wrapper">
                    <AddIcon className="create-event-icon" />
                </div>
                <div className="create-event-text">{buttonMessage}</div>
            </div>
        </div>
    )
}
